import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { User } from 'models/user';
import { useTranslation } from 'react-i18next';
import UpdateUserForm from './update-user-form';

type UpdateUserDialogProps = {
    dialogOpen: boolean;
    onDialogClose: () => void;
    userToUpdate: User;
    onUserUpdated: (user: User) => void;
    refetchUsers?: () => void;
};
const UpdateUserDialog: FC<UpdateUserDialogProps> = ({
    dialogOpen,
    onDialogClose,
    userToUpdate,
    onUserUpdated,
    refetchUsers,
}: UpdateUserDialogProps) => {
    const { t: translate } = useTranslation('users');

    return (
        <Dialog fullWidth maxWidth="md" open={dialogOpen} onClose={onDialogClose}>
            {/* DD-3577: this dialog edits technicians too, which it used to title "dentist". */}
            <DialogTitle id="add-dentist-title">
                {translate(userToUpdate.type === 'lab_technician' ? 'users:UPDATE_TECHNICIAN' : 'users:UPDATE_DENTIST')}
            </DialogTitle>
            <UpdateUserForm
                onDialogClose={onDialogClose}
                userToUpdate={userToUpdate}
                onUserUpdated={onUserUpdated}
                refetchUsers={refetchUsers}
            />
        </Dialog>
    );
};

export default UpdateUserDialog;
